import { cookieHTML } from '@webapp/landing/src/components/ru/docs/html/cookie';

import { Doc } from './doc';

export const DocsCookie: FC = () => (
    <Doc html={cookieHTML} subTitle='Политика использования Cookie-файлов' title='Оферта, договоры' />
);
